"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Bundle = _interopRequireDefault(require("../Bundle"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable import/no-unresolved */
var AppRoute = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function AppRoute() {
    var _this;
    _classCallCheck(this, AppRoute);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AppRoute, [].concat(args));
    // TODO: make more reliable implementation of this function
    _defineProperty(_this, "isReactComponent", function (component) {
      if (component.$$typeof && String(component.$$typeof).includes('react')) {
        return true;
      }
      if (component.prototype && component.prototype.render || String(component).includes('.createElement(')) {
        return true;
      }
      return false;
    });
    _defineProperty(_this, "EnhancedComponent", function (props) {
      var Layout = _this.props.layout;
      var Component = _this.props.component;
      var result;
      if (_this.isReactComponent(Component)) {
        // if real react component
        result = /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, _this.props.componentProps));
      } else {
        // if lazy loaded react module
        result = /*#__PURE__*/_react["default"].createElement(_Bundle["default"], {
          load: Component,
          onLoad: function onLoad(Mod) {
            return /*#__PURE__*/_react["default"].createElement(Mod, _extends({}, props, _this.props.componentProps));
          }
        });
      }
      return Layout ? /*#__PURE__*/_react["default"].createElement(Layout, _this.props.layoutProps, result) : result;
    });
    return _this;
  }
  _inherits(AppRoute, _React$Component);
  return _createClass(AppRoute, [{
    key: "render",
    value: function render() {
      var props = (0, _omit2["default"])(this.props, ['component', 'componentProps', 'layout']);
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, _extends({}, props, {
        component: this.EnhancedComponent
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(AppRoute, "propTypes", {
  component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]).isRequired,
  componentProps: _propTypes["default"].object,
  layout: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  layoutProps: _propTypes["default"].object
});
_defineProperty(AppRoute, "defaultProps", {
  componentProps: {},
  layoutProps: {}
});